export default __webpack_public_path__ + "static/media/small-logo-dubbing.a83cc95d.svg";